import { isEmpty } from 'lodash'

// From the backend details Not applicable (e.g. home owner)
const SERVICE_OFFERING_NOT_APPLICABLE = 'id_8'

export enum UserType {
  PRO = "Pro",
  CUSTOMER = "Customer",
  ANONYMOUS = "Anonymous",
}

export const getUserType = (org): UserType => {
  const auth = localStorage.getItem('auth')
  const authItem = auth ? JSON.parse(auth) : {}
  const roles = authItem.roles ?? undefined

  if (isEmpty(authItem)) {
    return UserType.ANONYMOUS
  }
  if (!org) {
    return UserType.ANONYMOUS
  }
  if (!roles || isEmpty(roles)) {
      return UserType.ANONYMOUS
  }
  if (org?.service_offering === SERVICE_OFFERING_NOT_APPLICABLE) {
    return UserType.CUSTOMER
  }

  return UserType.PRO
}